var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJira2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/Integrations/Jira@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "68.8997371%",
    y1: "40.3277751%",
    x2: "34.6012872%",
    y2: "62.6161943%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: "18%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.4592577%",
    y1: "59.165947%",
    x2: "65.5420462%",
    y2: "37.0763181%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC",
    offset: "18%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/Integrations/Jira",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Mask",
    fill: "#D8DDE4",
    opacity: 0.188313802,
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "jira",
    transform: "translate(4, 4)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7006029,11.8004464 L13.5781119,1.04276786 L12.4999877,0 L4.12739624,8.09794643 L0.299336813,11.8004464 C-0.0997789377,12.1869643 -0.0997789377,12.8130357 0.299336813,13.1995536 L7.94865209,20.5979464 L12.4999877,25 L20.8725703,16.9020536 L21.002213,16.7766964 L24.7006029,13.1995536 C25.099799,12.8130357 25.099799,12.1869643 24.7006029,11.8004464 Z M12.4999877,16.1958929 L8.67874079,12.5 L12.4999877,8.80410714 L16.3212347,12.5 L12.4999877,16.1958929 Z",
    id: "Shape",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.1103, 0.0296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38961826,8.77446429 C5.88783455,6.35434821 5.87560242,2.43458929 8.36238614,0 L0,8.08473214 L4.55131777,12.4867857 L8.38961826,8.77446429 Z",
    id: "Path",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.221133,12.4603571 L8.38970754,16.1660714 C9.59729586,17.3333929 10.2757775,18.9169643 10.2757775,20.568125 C10.2757775,22.219375 9.59729586,23.8029464 8.38970754,24.9702679 L16.772558,16.8624107 L12.221133,12.4603571 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira2X);
export default __webpack_public_path__ + "static/media/Jira@2x.0560973436a83b7f2966ee646e6224be.svg";
export { ForwardRef as ReactComponent };